import { useCallback, useRef, useState } from 'react';

import { getEdgeKey } from 'app/modules/wallforming/components/scenes/tools/quick-panel-replacement/utils/quickPanelReplacementUtils';

import type {
    EdgeHandle,
    MousePreview
} from 'app/modules/wallforming/components/scenes/tools/quick-panel-replacement/types/quickPanelReplacementTypes';

export const useReplacementStateHandler = () => {
    const [mousePreview, setMousePreview] = useState<MousePreview | null>(null);
    const [activeEdge, setActiveEdge] = useState<EdgeHandle | null>(null);

    const previewRef = useRef<MousePreview | null>(null);
    const mouseEdgeRef = useRef<EdgeHandle | null>(null);
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const initialCursorRef = useRef<string>('');

    const clearInteraction = useCallback(() => {
        mouseEdgeRef.current = null;
        previewRef.current = null;
        setActiveEdge(null);
        setMousePreview(null);
        if (canvasRef.current) {
            canvasRef.current.style.cursor = initialCursorRef.current;
        }
    }, []);

    const handleEdgeClick = useCallback(
        (edge: EdgeHandle) => {
            if (mouseEdgeRef.current && getEdgeKey(mouseEdgeRef.current) === getEdgeKey(edge)) {
                clearInteraction();
                return;
            }
            mouseEdgeRef.current = edge;
            previewRef.current = null;
            setActiveEdge(edge);
            setMousePreview(null);
            if (canvasRef.current) {
                canvasRef.current.style.cursor = 'crosshair';
            }
        },
        [clearInteraction]
    );

    return {
        activeEdge,
        canvasRef,
        clearInteraction,
        handleEdgeClick,
        initialCursorRef,
        mouseEdgeRef,
        mousePreview,
        previewRef,
        setActiveEdge,
        setMousePreview
    };
};
